export default __webpack_public_path__ + "static/media/gallery_08.db8ff7d1.jpg";